import { authFetch } from '~/services/fetch'

interface UserLoginActionsParams {
  readonly user_id?: number
  readonly station_id?: number
  readonly origin?: string | null
  readonly device_id: number | null
  readonly start_date: string
  readonly finish_date: string
  readonly page?: number
  readonly limit?: number
  readonly orders?: readonly { readonly field: string; readonly sort: string }[]
}

export async function getUserActionsSearchLogs(params: UserLoginActionsParams) {
  const { orders, ...otherParams } = params
  const response = await authFetch({
    url: '/user/login-actions',
    method: 'POST',
    data: {
      ...otherParams,
      orders: orders || [{ field: 'created_at', sort: 'desc' }],
    },
  })

  return response.data
}
